<template>
  <v-dialog
    v-model="value"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="handleCloseDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="handleCreateAttendance"
          >
            Save
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-card class="pl-5 pr-5 ">
          <div class="mt-5">
            <div class="text-h5 mt-5 mb-5 pt-5">
              Center: {{ centerDesc }}
            </div>
            <user-list
              ref="selectCoachList"
              :enable-search="true"
              :user-list="allCoachList"
              :rule="selectCoachRule"
              error-message="Please select one coach."
              @click="handleCoachClick"
              @remove="handleRemove"
            ></user-list>
            <v-form ref="createAttendanceForm">
              <v-row class="mt-1">
                <v-col>
                  <div>{{ checkinDateTimeConfig.label || checkinDateTimeConfig.toplabel }}</div>
                  <UniversalInput
                    v-model="checkinDateTime"
                    :config="checkinDateTimeConfig"
                  ></UniversalInput>
                </v-col><v-col>
                  <div>{{ checkoutDateTimeConfig.label || checkoutDateTimeConfig.toplabel }}</div>
                  <UniversalInput
                    v-model="checkoutDateTime"
                    :config="checkoutDateTimeConfig"
                  ></UniversalInput>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card>
        <!-- <v-card class="mt-10">
          <v-card-title>Clockin-out history</v-card-title>
          <div class="pb-2">
            <v-chip
              v-for="item in record.history"
              :key="item.id"
              outlined
            >
              {{ formatTime(item.checkTime) }}
            </v-chip>
          </div>
        </v-card> -->
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, onMounted, computed, toRefs, watch, onBeforeUnmount } from 'vue'
import { loadBundle } from 'firebase/firestore'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import { formatTime, loading } from '@/utils/helper'
import { createItem, listCoach } from '@/api/coachAttendance'
import UserList from '@/components/UserSelector/UserList'
import moment from '@/utils/moment'

const allCoachList = ref([])

const createAttendanceForm = ref(null)
const isError = ref(false)
function handleError(e) {
  isError.value = true
}

const accountImage = computed(() => require('@/assets/images/AsianAlliance/account-circle.png'))

const title = ref('Attendance Details')

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  centerId: {
    type: Number,
    default: -1,
  },
  centerDesc: {
    type: String,
    default: '',
  },
  attendanceDate: {
    type: String,
    default: '0001-01-01T00:00:00.000Z',
  },
})

const emits = defineEmits(['input', 'close'])

const { value, record, centerId, attendanceDate } = toRefs(props)

const avatar = computed(() => process.env.VUE_APP_BASE_API + record.value.userRecord.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')

const userRecordID = ref(-1)
function handleCoachClick(item) {
  userRecordID.value = item.id
}
function handleRemove() {
  userRecordID.value = -1
}

function selectCoachRule() {
  return userRecordID.value !== -1
}

// const attendanceDate = ref(record.value.attendanceDate)

const checkinDateTime = ref(attendanceDate.value)
const checkoutDateTime = ref(attendanceDate.value)

const checkinDateTimeConfig = ref({
  propName: 'checkinDateTime',
  toplabel: 'Select Checkin Time',
  required: true,
  type: {
    name: 'timepicker',
    step: 5,
  },
})
function checkoutValidator(v) {
  console.log('checkinDateTime', checkinDateTime.value)
  console.log('checkoutDateTime', checkoutDateTime.value)
  console.log('moment', moment)
  if (moment(checkinDateTime.value).isBefore(moment(checkoutDateTime.value))) {
    return true
  }

  return false
}
const checkoutDateTimeConfig = ref({
  propName: 'checkoutDateTime',
  toplabel: 'Select Checkout Time',
  required: true,
  type: {
    name: 'timepicker',
    step: 5,
    rules: [
      v => checkoutValidator(v) || 'Checkout Time is required',
    ],
  },
})

// watch(attendanceDate, newVal => {
//   checkinDateTime.value = newVal
//   checkoutDateTime.value = newVal
// })

const selectCoachList = ref(null)

watch(value, newVal => {
  // console.log('record', newVal)
  // checkinDateTime.value = newVal.checkinDateTime
  // checkoutDateTime.value = newVal.checkoutDateTime
  if (newVal) {
    listCoach({
      id: centerId.value,
      page: 0,
      limit: 0,
    }).then(response => {
      console.log('listCoach', response)
      const { data } = response

      // commit('SET_COACHLIST', data.items)
      // resolve(data.items)
      allCoachList.value.length = 0
      if (data.items) {
        allCoachList.value.push(...data.items)
      }
    })
      .catch(error => {
        console.log('error', error)

      // reject(error)
      }).finally(() => {
      // this.isLoading = false
      })
  }
})

function handleCloseDialog() {
  console.log('handleCloseDialog')

  checkinDateTime.value = attendanceDate.value
  checkoutDateTime.value = attendanceDate.value
  userRecordID.value = -1
  selectCoachList.value.selectedList = []
  selectCoachList.value.resetValidation()
  console.log('checkinDateTime.value', checkinDateTime.value)
  console.log('checkoutDateTime.value', checkoutDateTime.value)
  console.log('userRecordID.value', userRecordID.value)
  console.log('selectCoachList.value', selectCoachList.value)
  emits('input', false)
  emits('close')
}

function handleCreateAttendance() {
  const formValidateResult = createAttendanceForm.value.validate()

  const userValidation = selectCoachList.value.validate()
  console.log('userValidation', userValidation)
  if (!formValidateResult || !userValidation) {
    return ''
  }

  loading(true)
  const postData = {
    centerID: centerId.value,
    attendanceDate: attendanceDate.value,
    checkinDateTime: checkinDateTime.value,
    checkoutDateTime: checkoutDateTime.value,
    userRecordID: userRecordID.value,
  }
  console.log('postData', postData)
  createItem(postData).then(res => {
    console.log('res', res)
    handleCloseDialog()
  }).catch(err => {
    console.log('err', err)
  }).finally(() => {
    loading(false)
  })
}
</script>
